import React from "react";

/** Gold-tinted skeleton shapes — spec §2. AuditIQ brand: navy bg + gold pulse. */
const baseStyle = {
  background:
    "linear-gradient(90deg, rgba(201,168,76,0.06) 0%, rgba(201,168,76,0.18) 50%, rgba(201,168,76,0.06) 100%)",
  backgroundSize: "200% 100%",
  borderRadius: 6,
  animation: "auditiqShimmer 1.6s ease-in-out infinite",
};

// Inject keyframes once at module load
if (typeof document !== "undefined" && !document.getElementById("auditiq-shimmer-kf")) {
  const style = document.createElement("style");
  style.id = "auditiq-shimmer-kf";
  style.textContent = `
    @keyframes auditiqShimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
    .auditiq-skeleton-fade {
      animation: auditiqFadeIn 200ms ease-out;
    }
    @keyframes auditiqFadeIn {
      from { opacity: 0; transform: translateY(2px); }
      to { opacity: 1; transform: none; }
    }
  `;
  document.head.appendChild(style);
}

export const SkeletonLine = ({ width = "100%", height = 14, className = "" }) => (
  <div
    data-testid="skeleton-line"
    className={className}
    style={{ ...baseStyle, width, height, marginBottom: 8 }}
  />
);

export const SkeletonBlock = ({ height = 120, className = "" }) => (
  <div
    data-testid="skeleton-block"
    className={className}
    style={{ ...baseStyle, height, width: "100%" }}
  />
);

/** Card-shaped skeleton matching AuditIQ panel aesthetic. */
export const SkeletonPanel = ({ title = "Loading…", lines = 4, testId = "skeleton-panel" }) => (
  <div
    data-testid={testId}
    style={{
      background: "#112244",
      border: "2px double #c9a84c",
      borderRadius: 8,
      padding: 20,
      boxShadow: "inset 0 0 0 1px rgba(201,168,76,0.4)",
    }}
  >
    <div
      style={{
        fontFamily: "Cinzel, Georgia, serif",
        color: "#c9a84c",
        fontSize: 12,
        letterSpacing: 2,
        textTransform: "uppercase",
        marginBottom: 12,
        opacity: 0.7,
      }}
    >
      {title}
    </div>
    <SkeletonLine width="68%" height={20} />
    <div style={{ height: 12 }} />
    {Array.from({ length: lines }).map((_, i) => (
      <SkeletonLine key={i} width={`${60 + ((i * 13) % 35)}%`} />
    ))}
  </div>
);

/** Grid of skeleton cards for KPI rows. */
export const SkeletonKPIRow = ({ count = 4 }) => (
  <div
    data-testid="skeleton-kpi-row"
    style={{
      display: "grid",
      gridTemplateColumns: `repeat(auto-fit, minmax(200px, 1fr))`,
      gap: 16,
    }}
  >
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        style={{
          background: "#112244",
          border: "1px solid rgba(201,168,76,0.3)",
          borderRadius: 8,
          padding: 16,
        }}
      >
        <SkeletonLine width="50%" height={11} />
        <div style={{ height: 8 }} />
        <SkeletonLine width="80%" height={28} />
      </div>
    ))}
  </div>
);

export default SkeletonPanel;
